module.exports = __webpack_public_path__ + "static/media/Montserrat-SemiBold.31e34a4d.ttf";